(() => {
  if (window.ogRecipeHoverInitialized) return;
  window.ogRecipeHoverInitialized = true;
  const cache = new Map();
  const queue = [];
  let active = 0;

  async function drain() {
    if (active >= 2 || !queue.length) return;
    active++;
    const { url, resolve } = queue.shift();
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recipe unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const description = doc.querySelector('.dt-recipe__description, .dt-og-recipe__description');
      if (description) {
        description.querySelectorAll('br').forEach(br => br.replaceWith(' '));
        description.querySelectorAll('p, li, div').forEach(block => block.append(' '));
      }
      resolve(description ? description.textContent.replace(/\s+/g, ' ').trim() : '');
    } catch (_) {
      // Keep the server-rendered excerpt and the original recipe link on failure.
      cache.delete(url);
      resolve('');
    } finally {
      clearTimeout(timeout);
      active--;
      drain();
    }
  }

  function updateDescription(card, text) {
    const characters = Array.from(text);
    const summary = characters.length > 70 ? characters.slice(0, 69).join('').trimEnd() + '…' : text;
    const overlay = card.querySelector('.og-recipe-card__overlay');
    if (overlay) overlay.textContent = text;
    const full = card.querySelector('.og-recipe-card__full-description');
    const short = card.querySelector('.og-recipe-card__mobile-summary');
    if (full) full.textContent = text;
    if (short) short.textContent = summary;
  }

  function load(card) {
    const link = card.querySelector('.og-recipe-card__image, .article__title');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    // Preserve the theme preview when reviewing an unpublished theme.
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    if (!cache.has(url.href)) {
      cache.set(url.href, new Promise(resolve => {
        queue.push({ url: url.href, resolve });
        drain();
      }));
    }
    cache.get(url.href).then(text => {
      if (!text || !card.isConnected) return;
      updateDescription(card, text);
    });
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      load(entry.target);
    });
  }, { rootMargin: '400px' }) : null;

  function init(root) {
    root.querySelectorAll('.og-recipe-card:not([data-recipe-hover-ready])').forEach(card => {
      card.dataset.recipeHoverReady = 'true';
      const initial = card.querySelector('.og-recipe-card__full-description');
      if (initial) updateDescription(card, initial.textContent.replace(/\s+/g, ' ').trim());
      if (observer) observer.observe(card);
      else load(card);
      card.addEventListener('pointerenter', () => load(card));
      card.addEventListener('focusin', () => load(card));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
